const animate = ({ $el, animation, prevAnimation, delay, callback }) => {
  $el.classList.remove('animate');
  $el.classList.remove(prevAnimation);
  $el.classList.remove(delay);

  $el.classList.add('animate');
  $el.classList.add( animation);
  $el.classList.add(delay)

  document.addEventListener(
    'animationend',
    function animationEndHandler(e) {
      if (e.target.classList.contains($el.classList[0])) {
        document.removeEventListener('animationend', animationEndHandler);

        if (typeof callback === 'function') callback();
      }
    },
    false,
  );
};

module.exports = animate;
